import { render, staticRenderFns } from "./ModalHistoricoBaixas.vue?vue&type=template&id=ce8ac940&scoped=true"
import script from "./ModalHistoricoBaixas.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoBaixas.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoBaixas.vue?vue&type=style&index=0&id=ce8ac940&prod&scoped=true&lang=scss"
import style1 from "./ModalHistoricoBaixas.vue?vue&type=style&index=1&id=ce8ac940&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8ac940",
  null
  
)

export default component.exports